/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type EmailFeedbackInput = {
    message?: string | null;
    files?: Array<string | null> | null;
    clientMutationId?: string | null;
};
export type useEmailFeedbackMutationVariables = {
    input: EmailFeedbackInput;
};
export type useEmailFeedbackMutationResponse = {
    readonly emailFeedback: {
        readonly error: string | null;
    } | null;
};
export type useEmailFeedbackMutation = {
    readonly response: useEmailFeedbackMutationResponse;
    readonly variables: useEmailFeedbackMutationVariables;
};



/*
mutation useEmailFeedbackMutation(
  $input: EmailFeedbackInput!
) {
  emailFeedback(input: $input) {
    error
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "EmailFeedbackPayload",
    "kind": "LinkedField",
    "name": "emailFeedback",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useEmailFeedbackMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useEmailFeedbackMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8e134d0c0fe7bd28013637c234fe5991",
    "id": null,
    "metadata": {},
    "name": "useEmailFeedbackMutation",
    "operationKind": "mutation",
    "text": "mutation useEmailFeedbackMutation(\n  $input: EmailFeedbackInput!\n) {\n  emailFeedback(input: $input) {\n    error\n  }\n}\n"
  }
};
})();
(node as any).hash = '7f552fae473a5fe26c64f8740cd71ccf';
export default node;
